module.exports = __webpack_public_path__ + "static/16-bea70471fa24d2f13ca76dee0bd0c077.jpg";